import { useCallback } from "react";
import { APP_CONFIG } from "../config/appConfig";

export function useVibration() {
    return useCallback((pattern) => {
        if (!APP_CONFIG.vibrationEnabled || !navigator.vibrate) return;
        navigator.vibrate(pattern);
    }, []);
}
